export default __webpack_public_path__ + "circle_selection_unchecked.c9ad3452.svg";